import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-91f741b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "price-section" }
const _hoisted_2 = { class: "btn-row" }

import { reactive } from 'vue';
import NftDetail from '@/components/NFT/Detail.vue';
import TransferDialog from '@/components/NFT/TransferDialog.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const transferDialog = reactive({
  visible: false,
});

function sellNft() {
  // TODO trx call
}

function showTransferDialog() {
  transferDialog.visible = true;
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(NftDetail, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_button, {
            class: "sell-btn",
            onClick: sellNft,
            size: "small"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('sell')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            class: "transfer-btn",
            onClick: showTransferDialog,
            size: "small"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('transfer')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(TransferDialog, {
        visible: _unref(transferDialog).visible,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_unref(transferDialog).visible) = $event))
      }, null, 8, ["visible"])
    ]),
    _: 1
  }))
}
}

})